import React from 'react';
import { connect } from 'react-redux';
import Memorial from './Memorial/Memorial';
import Scene from './Scene/Scene';
import ProjectInfo from './ProjectInfo/ProjectInfo';
import SubPage from '../../Shared/SubPage/SubPage';
import { SUB_PAGE } from '../../../constants';
import './Dukla.css';
import SceneCompact from './SceneCompact/SceneCompact';

const Dukla = props => {
  const { subPage, compact } = props;
  return (
    <div
      id="dukla"
      className={subPage.length === 0 && !compact ? 'crop' : 'auto'}
      onMouseMove={this.handleMouseMove}
    >
      {!compact && <Scene />}
      {compact && subPage.length === 0 && <SceneCompact />}

      {subPage === SUB_PAGE.MEMORIAL && (
        <SubPage>
          <Memorial />
        </SubPage>
      )}
      {subPage === SUB_PAGE.INFO && (
        <SubPage>
          <ProjectInfo />
        </SubPage>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  subPage: state.app.subPage,
  compact: state.ui.compact,
});

export default connect(mapStateToProps)(Dukla);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Dukla.js